export const ApiResponseStatus ={
    SUCCESS:"SUCCESS",
    ERROR:"ERROR",
    WARNING:"WARNING"
}